import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import axios from "axios"
import config from "config/config"
import CampaignCard from "./CampaignCard" // Campaign Overview
import SurveyDistributionCard from "./SurveyDIstributionCard" // New Component
import SurveyDistributionDetails from "./SurveyDistributionDetail" // The new details card
import { Spinner } from "reactstrap"

const CampaignDetails = () => {
  const { id } = useParams()
  const [campaign, setCampaign] = useState(null)
  const [loading, setLoading] = useState(false)
  const [err, setErr] = useState(null)
  const [selectedDistribution, setSelectedDistribution] = useState(null)

  useEffect(() => {
    const fetchCampaign = async () => {
      setLoading(true)
      setErr(null)
      try {
        const response = await axios.get(
          `${config.backendUrl}/survey/getCampaignByIdWithSentiment/${id}`,
        )
        setCampaign(response.data.campaign)
      } catch (error) {
        setErr(error.response?.data?.message || "Failed to fetch campaign")
      } finally {
        setLoading(false)
      }
    }

    if (id) fetchCampaign()
  }, [id])

  return (
    <div className="">
      {campaign && (
        <>
          {/* Campaign Overview */}
          <CampaignCard campaign={campaign} loading={loading} />

          {/* Survey Distributions Section */}
          <h4 className="mt-4 mb-3">Survey Distributions</h4>

          {/* Row of distribution cards */}
          <div className="d-flex br">
            {campaign.SurveyDistributions?.length > 0 ? (
              campaign.SurveyDistributions.map((distribution, index) => (
                <SurveyDistributionCard
                  key={index}
                  distribution={distribution}
                  onClick={() => setSelectedDistribution(distribution)}
                  isSelected={selectedDistribution?.id === distribution.id}
                />
              ))
            ) : (
              <p className="text-muted">No survey distributions available.</p>
            )}
          </div>

          {/* Show the details card below when a distribution is selected */}
          {selectedDistribution && (
            <SurveyDistributionDetails
              distribution={selectedDistribution}
              onClose={() => setSelectedDistribution(null)}
            />
          )}
        </>
      )}
    </div>
  )
}

export default CampaignDetails
